<template>
  <dialog-confirm
    ref="dialog"
    v-on:onclose="$_onClose"
    :loading="loading"
    :confirm-btn="confirmBtn"
    @submit="$_onSubmit"
  >
    <template #title>
      <span
        :style="`text-transform: uppercase; color: ${$_colorByTheme()};`">
        {{ dialogTitle }}
      </span>
    </template>

    <v-alert colored-border dense
      v-if="alertTitle || alertMessage"
      :color="$_colorByTheme()"
      :class="`${$_classByTheme()} lighten-5`"
      border="left"
      type="warning"
    >
      <!-- <div>{{ alertTitle }}</div> -->
      <!-- <div v-if="alertTitle && alertMessage" class="mt-2" /> -->
      <div class="dialog-delete-color" v-if="alertMessage" v-html="alertMessage" />
    </v-alert>

    <div>{{ message }}</div>

    <div v-if="confirmText" class="mt-3">
      {{ $t('dialogDelete.message') }}
      <code>{{ confirmText }}</code>

      <!-- eslint-disable -->
      <vl-text-field
        hide-details
        autofocus
        v-model="confirmValue"
        color="red"
        class="mt-3"
        :disabled="loading"
      />
      <!-- eslint-enable -->
    </div>

    <div v-if="inputText">
      <code>{{ inputText }}</code>

      <!-- eslint-disable -->
      <vl-text-field
        hide-details
        autofocus
        :label="$t('dialogDelete.observationNote')"
        v-model="inputValue"
        color="red"
        class="mt-3"
        :disabled="loading"
      />
      <!-- eslint-enable -->
    </div>
  </dialog-confirm>
</template>

<script>
import { mapActions } from 'vuex';
import DeleteDialogEvent from '@/events/DeleteDialogEvent';
import DialogConfirm from './DialogConfirm.vue';

export default {
  name: 'DialogDelete',

  components: {
    DialogConfirm,
  },

  data() {
    return {
      loading: false,

      message: null,

      dialogTitle: null,
      alertTitle: null,
      alertMessage: null,
      theme: 'red',

      confirmText: null,
      confirmValue: null,
      onConfirmHandler: null,
      onCloseHandler: null,

      confirmBtnOrigin: {
        color: 'red',
        icon: 'mdi-delete',
        dark: this.inputText
          ? this.inputValue !== null
          : this.confirmText === this.confirmValue,
        label: this.$t('delete'),
        disabled: this.inputText
          ? this.inputValue === null
          : this.confirmText !== this.confirmValue,
      },

      confirmBtn: null,

      inputText: null,
      inputValue: null,
    };
  },

  methods: {
    ...mapActions({
      setInputTextFromStore: 'modaldelete/setInputText',
    }),

    $_showDialog({
      detail: {
        message,
        alertTitle,
        alertMessage,
        confirmText,
        onConfirmHandler,
        inputText,
        onCloseHandler,
        confirmBtn,
        theme,
      },
    }) {
      this.alertMessage = alertMessage ?? null;
      this.alertTitle = (alertMessage && this.$t('dialogDelete.alertTitle')) ?? null;
      this.dialogTitle = alertTitle ?? this.$t('delete');
      this.message = message ?? this.$t('dialogDelete.defaultMessage');
      this.theme = theme ?? 'red';

      if (confirmBtn) this.confirmBtn = confirmBtn;
      else this.confirmBtn = this.confirmBtnOrigin;
      this.onConfirmHandler = onConfirmHandler ?? null;
      this.onCloseHandler = onCloseHandler ?? null;
      this.confirmText = confirmText ?? null;
      this.inputText = inputText ?? null;
      this.confirmValue = null;
      this.inputValue = null;
      this.$refs.dialog.show();
    },

    async $_onSubmit() {
      if (!this.onConfirmHandler) return;

      this.loading = true;
      this.setInputTextFromStore({ inputText: this.inputValue });

      try {
        if (await this.onConfirmHandler()) {
          this.$refs.dialog.close();
        }
      } finally {
        this.loading = false;
      }
    },

    $_onClose() {
      if (this.onCloseHandler) this.onCloseHandler();
    },

    $_colorByTheme() {
      switch (this.theme) {
        case 'success':
          return 'green';

        default:
          return 'red';
      }
    },

    $_classByTheme() {
      switch (this.theme) {
        case 'success':
          return 'success';

        default:
          return 'red';
      }
    },
  },

  created() {
    DeleteDialogEvent.on(this.$_showDialog);
  },

  beforeDestroy() {
    DeleteDialogEvent.off(this.$_showDialog);
  },
  create() {
    console.log(this.$vuetify); // ⚠️ Pode disparar o erro
  },
  watch: {
    inputValue: {
      deep: true,
      async handler(value) {
        if (value === '') this.inputValue = null;
      },
    },
  },
};
</script>

<style scoped>
.dialog-delete-color {
  color: rgba(0, 0, 0, 0.7);
}
</style>
